import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_IDEAL: MijnRoute = {
    path: 'ideal',
    navigationEvent: 'toIdealZelfservice',
    regex: /^\/zelf-regelen\/ideal$/,
    webcomponent: 'mijn-ideal-zelfservice-webcomponent'
};
